/* ============
 * Recipe Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class RecipeProcedureTransformer extends Transformer {

  static fetch(recipeProcedure) {
    return {
      id: recipeProcedure.id,
      name: recipeProcedure.name,
      step: recipeProcedure.step,
      recipeId: recipeProcedure.recipe_id,
      recipe: recipeProcedure.recipe,
      procedureId: recipeProcedure.procedure_id,
      procedure: recipeProcedure.procedure,
      equipmentId: recipeProcedure.equipment_id,
      equipment: recipeProcedure.equipment,
      status: recipeProcedure.status,
      dateStart: recipeProcedure.date_start,
      dateEnd: recipeProcedure.date_end,
      ingrediences: recipeProcedure.ingrediences,
      notes: recipeProcedure.notes,
    };
  }

  static send(recipeProcedure) {
    return {
      id: recipeProcedure.id,
      name: recipeProcedure.name,
      step: recipeProcedure.step,
      recipe_id: recipeProcedure.recipeId,
      procedure_id: recipeProcedure.procedureId,
      equipment_id: recipeProcedure.equipmentId,
      ingredience_ids: recipeProcedure.ingredienceIds,
      notes: recipeProcedure.notes,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/recipeProcedure.js